module.exports = __webpack_public_path__ + "static/media/jenniferkoper-IG.023727e9.PNG";